import { addDays } from 'date-fns'

export default {
  name: 'project_event_end_date',
  component_path: 'modules/procedures/blocks/BlockInputDate',
  default_value: 'default_values.project.event_end_date',
  static_options: {
    open_date: addDays(new Date(), 1),
    show_time: 'project_display_settings.event.show_time'
  }
}